import { disableMainButton, enableMainButton } from '@/ui/mainButton';
import { CloseX } from '@/ui/svg';
import { useGlobalValueStore } from '@bitbot/model';
import { useMainButton, useHapticFeedback } from '@bitbot/shared/bridge';
import React, { useCallback, useEffect } from 'react';

export default function InputWalletName({
  name,
  setName,
}: {
  name: string;
  setName: (name: string) => void;
}) {
  const mainButton = useMainButton();
  const hapticFeedBack = useHapticFeedback();
  const { setShowInputWalletName } = useGlobalValueStore();

  const handleClick = useCallback(() => {
    setShowInputWalletName(false);
    hapticFeedBack?.impactOccurred('light');
  }, []);
  useEffect(() => {
    mainButton?.setText('Continue');
    mainButton?.show();
    mainButton?.on('click', handleClick);
    return () => {
      mainButton?.off('click', handleClick);
      mainButton?.hide();
    };
  }, []);

  useEffect(() => {
    if (name.trim() === '') {
      disableMainButton(mainButton);
    } else {
      mainButton?.show();
      enableMainButton(mainButton);
    }
  }, [name]);
  return (
    <div className="fixed inset-0 bg-primary z-[999] p-4">
      <div className="relative">
        <input
          className="bg-secondary rounded-[12px] outline-none w-full p-6 pr-16 placeholder:text-quaternary text-lg"
          placeholder="Wallet name"
          value={name}
          maxLength={20}
          onChange={e => {
            setName(e.target.value);
          }}
        />
        <div
          onClick={() => {
            setName('');
          }}
          className="absolute right-8 top-[50%] translate-y-[-50%] cursor-pointer"
        >
          <CloseX className="text-quaternary w-[22px] h-[22px]" />
        </div>
      </div>
    </div>
  );
}
